import * as React from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';

// Utils
import { isNil } from '@src/shared/src/util/general';
import { canOptOutOfFlexLane } from '@src/shared/src/util/flexlane';
import { t } from '@toolkit/util/i18n';
import { notifyTranslatedError } from '@toolkit/util/app';
// Actions
import { checkoutActions } from '@src/shared/src/actions';
// Models
import { BasketItemModel } from '@src/shared/src/models';
// Components
import Switch from '@pod/filters/components/Switch';
// Styles
import '../styles/FlexLaneOptOut.scss';

type Props = {
  basketItem:BasketItemModel;
  label:string;
};

export const FlexLaneOptOutRow:React.FC<Props> = ({ basketItem, label }) => {
  const dispatch = useDispatch();
  const optedOut = basketItem?.travelBookingItem?.flexlaneOptedOut === true;
  const [requestedOptOut, setRequestedOptOut] = React.useState<boolean>(null);

  // Nothing is written to the store: the basket re-broadcast moves `optedOut`. Hold the requested
  // position until it lands, then drop it.
  React.useEffect(() => setRequestedOptOut(null), [optedOut]);

  if (!canOptOutOfFlexLane(basketItem)) {
    return null;
  }

  const isPending = !isNil(requestedOptOut);
  const isRemoved = isPending ? requestedOptOut : optedOut;

  const onChange = (isCovered:boolean) => {
    setRequestedOptOut(!isCovered);
    dispatch(checkoutActions.setFlexLaneOptOutAsync.request({
      travelBookingItemId: Number(basketItem.travelBookingItem.id),
      optedOut: !isCovered,
      onError: (messages:string[]) => {
        setRequestedOptOut(null);
        notifyTranslatedError(messages);
      },
    }));
  };

  return (
    <div className={classNames('lp-flexlane-opt-out', { 'is--removed': isRemoved })}>
      <i className="material-symbols lp-flexlane-opt-out-icon">free_cancellation</i>
      <span className="lp-flexlane-opt-out-label">
        {isRemoved ? t('flexLaneOptOut.label.removed', { defaultValue: 'FlexLane removed' }) : label}
      </span>
      <Switch isChecked={!isRemoved} isDisabled={isPending} onChange={onChange} />
    </div>
  );
};
